/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

import { tId } from './common';
import { tReservationModeV2 } from './schemas';

export const tStoreSchedule = t.type({
  id: t.union([tId, t.null]),
  schedule_type: t.union([tReservationModeV2, t.null]),
  sunday_hours_start: t.union([t.string, t.null]),
  sunday_hours_end: t.union([t.string, t.null]),
  monday_hours_start: t.union([t.string, t.null]),
  monday_hours_end: t.union([t.string, t.null]),
  tuesday_hours_start: t.union([t.string, t.null]),
  tuesday_hours_end: t.union([t.string, t.null]),
  wednesday_hours_start: t.union([t.string, t.null]),
  wednesday_hours_end: t.union([t.string, t.null]),
  thursday_hours_start: t.union([t.string, t.null]),
  thursday_hours_end: t.union([t.string, t.null]),
  friday_hours_start: t.union([t.string, t.null]),
  friday_hours_end: t.union([t.string, t.null]),
  saturday_hours_start: t.union([t.string, t.null]),
  saturday_hours_end: t.union([t.string, t.null]),
});
export type StoreSchedule = t.TypeOf<typeof tStoreSchedule>;
